import BarChartWithInfoSnippets from './BarChartWithInfoSnippets';

export type { BarChartWithInfoSnippetsProps } from './BarChartWithInfoSnippets';

export default BarChartWithInfoSnippets;
